<template>
  <div style="background: gray">
    <h3>Theme</h3>

    <div>
      <h4>Room background</h4>
      <div style="display: flex; gap: 8px">
        <button @click="setBackgroundColor(color)" v-for="color in colors" style="padding: 4px" :key="color">
        <span :style="{
          ...((roomTheme && roomTheme.roomBackgroundColor === color) && {border: 'solid black'}),
          width: '48px', display: 'block', height: '48px', background: color
        }"></span>
        </button>
      </div>
    </div>

    <div>
      <h4>Waiting room background</h4>
      <div style="display: flex; gap: 8px">
        <button @click="setWaitingBackgroundColor(color)" v-for="color in colors" style="padding: 4px" :key="color">
        <span :style="{
          ...((roomTheme && roomTheme.waitingRoomBackgroundColor === color) && {border: 'solid black'}),
        width: '48px', display: 'block', height: '48px', background: color
        }"></span>
        </button>
      </div>
      <div v-if="!sameRoomColors">
        <input @change="setSameRoomColors()" :checked="sameRoomColors" type="checkbox"
               name="sameAsRoomBackground" id="sameAsRoomBackground">
        <label for="sameAsRoomBackground">Use same as room background</label>
      </div>
    </div>

    <div>
      <h4>Room Logo</h4>
      <div v-if="roomTheme.logoURL">
        <img style="max-height: 72px" :src="roomTheme.logoURL"/>
        <button @click="removeLogo">Remove logo</button>
      </div>
      <div>
        <div v-if="logoPreviewDataURL">
          <h5>Logo preview</h5>
          <img style="max-height: 72px" :src="logoPreviewDataURL"/>
          <br>
          <button @click="saveLogo">Save changes</button>
        </div>
        <input @change="onLogoSelected($event)" type="file" accept="image/png, image/jpeg, image/webp">
      </div>
    </div>
    <div>
      <h4>Room background image</h4>
      <div v-if="roomTheme.backgroundURL">
        <img style="max-height: 72px" :src="roomTheme.backgroundURL"/>
        <button @click="removeBackground">Remove background image</button>
      </div>
      <div>
        <div v-if="backgroundPreviewDataURL">
          <h5>Logo preview</h5>
          <img style="max-height: 72px" :src="backgroundPreviewDataURL"/>
          <br>
          <button @click="saveBackground">Save changes</button>
        </div>
        <input @change="onBackgroundSelected($event)" type="file" accept="image/png, image/jpeg, image/webp">
      </div>
    </div>
  </div>
</template>

<script>
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";
import {getAuth} from "firebase/auth";

export default {
  name: "UpdateRoomTheme",
  computed: {
    roomTheme() {
      return this.$store.getters.roomTheme
    },
    sameRoomColors() {
      return this.roomTheme?.roomBackgroundColor === this.roomTheme?.waitingRoomBackgroundColor
    }
  },
  data() {
    return {
      logoFile: null,
      logoPreviewDataURL: null,
      backgroundFile: null,
      backgroundPreviewDataURL: null,
      colors: [
        "#ffffff",
        "#f2eed8",
        "#b6ebeb",
        "#b9e0d9"
      ]
    }
  },
  methods: {
    async removeLogo() {
      await this.$store.dispatch("setLogo", {delete: true})
    },
    async removeBackground() {
      await this.$store.dispatch("setBackground", {delete: true})
    },
    async saveLogo() {

      await this.$store.dispatch("setLogo", this.logoFile)

      this.logoPreviewDataURL = null
      this.logoFile = null
    },
    async saveBackground() {

      await this.$store.dispatch("setBackground", this.backgroundFile)

      this.backgroundPreviewDataURL = null
      this.backgroundFile = null
    },
    onLogoSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      this.logoFile = file
      this.logoPreviewDataURL = URL.createObjectURL(file)

      event.target.value = ''
    },

    onBackgroundSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      this.backgroundFile = file
      this.backgroundPreviewDataURL = URL.createObjectURL(file)

      event.target.value = ''
    },
    setSameRoomColors() {
      this.$store.dispatch("setSameRoomColors")
    },
    setBackgroundColor(color) {
      this.$store.dispatch("setRoomBackgroundColor", color)
    },
    setWaitingBackgroundColor(color) {
      this.$store.dispatch("setRoomWaitingBackgroundColor", color)
    },
  }
}
</script>

<style scoped>

</style>